import React, { Component } from "react";
import Axios from "axios";
import { Link } from "react-router-dom";
import Constant from "../Constant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";

import "../../css/style.css";
import $ from "jquery";
import { getAccessToken } from "../../hooks/AccessToken";

class DataManagement extends Component {
  state = {
    ERROR: true,
    DataList: [],
    selectValue: "",
    length: "",
    pageNo: "",
    defaultPageNo: 1,
    searchKey: "",
    sortByAttribute: 1,
  };

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  //----------------------------------Change status-----------------------------------------------\\

  changeStatus = async (id, status) => {
    try {
      let token = getAccessToken();
      const response = await Axios.patch(
        Constant.apiBasePath + "category/changeStatus/" + id,
        { status: status },
        { headers: { token: token } }
      );
      let { data } = response;
      if (data.status === Constant.statusSuccess) {
        $("#gen-message").text(data.message);
        $("#gen-message").css("color", "green");
        this.handleSubmit(this.state.defaultPageNo);
      } else {
        $("#gen-message").text(data.message);
        $("#gen-message").css("color", "red");
      }
    } catch (err) {
      console.log(err);
    }
  };

  //------------------------------------Integrate API for remove banner-------------------------------//

  deleteCategory = async (event) => {
    try {
      let token = getAccessToken();
      const response = await Axios.delete(
        Constant.apiBasePath + "category/" + event,
        { headers: { token: token } }
      );
      let data = response.data;
      if (data.status === Constant.statusSuccess) {
        $("#gen-message").text(data.message);
        $("#gen-message").css("color", "green");
        this.handleSubmit(this.state.defaultPageNo);
        setTimeout(function () {
          $("#gen-message").text("");
        }, 3000);
      } else {
        $("#gen-message").text(data.message);
        $("#gen-message").css("color", "red");
        setTimeout(function () {
          $("#gen-message").text("");
        }, 3000);
      }
    } catch (err) {
      console.log(err);
    }
  };

  //----------------------------------Integrate API for update banner-------------------------------\\

  updateCategory = async (event) => {
    try {
      this.props.history.push("/update-category/" + event);
    } catch (err) {
      console.log(err);
    }
  };

  //----------------------------------Integrate show banner API----------------------------------\\

  handleSubmit = async (event, sort) => {
    try {
      let token = getAccessToken();
      let selectValue = $("#selectValue").val();
      let searchKey = $("#searchKey").val();
      let sortByAttribute = this.state.sortByAttribute;
      if (sort) {
        this.setState({ sortByAttribute: sort });
        sortByAttribute = sort;
      }
      const response = await Axios.post(
        Constant.apiBasePath + "category/get-all",
        {
          key: selectValue,
          pageNo: event,
          searchKey: searchKey,
          sortByAttribute: sortByAttribute,
        },
        { headers: { token: token } }
      );
      const { data, length, pageNo } = response.data;
      this.setState({
        DataList: data,
        length: length,
        pageNo: pageNo,
        defaultPageNo: event,
        selectValue: "",
        searchKey: "",
        ERROR: false,
      });
    } catch (err) {
      console.log(err);
    }
  };

  //--------------------------------------------Reload component----------------------------------------------//
  componentDidMount() {
    this.handleSubmit(this.state.defaultPageNo);
  }

  //-------------------------------------------End API-------------------------------------------------------\\

  render() {
    const { DataList, length, pageNo } = this.state;
    let i = (pageNo - 1) * Constant.perPage;

    let bodyData = "";
    if (DataList.length > 0) {
      bodyData = DataList.map((el) => {
        i++;
        let status = "Inactive";
        let statusClass = "is-inactive";
        if (el.status === 1) {
          status = "Active";
          statusClass = "is-active";
        }

        let contestType = "General";
        if (el.contestType) {
          contestType = "Contest";
        }
        return (
          <tr key={el._id}>
            <td>{i}</td>
            <td className="namecol">{el.name}</td>
            <td>
              <img
                src={el.icon}
                alt="ind"
                style={{ width: 50, height: 50 }}
                key={el._id}
                resizemode="contain"
              />
            </td>
            <td>{contestType}</td>
            <td>{el.createdAt}</td>
            <td className="category-status-col">
              <button
                className={`contest-status-pill ${statusClass} category-status-btn`}
                onClick={() => {
                  this.changeStatus(el._id, el.status);
                }}
              >
                {status}
              </button>
            </td>
            <td className="actions-col category-actions-col">
              <div className="category-actions-wrap">
                <button
                  type="button"
                  className="contest-icon-btn danger"
                  title="Delete Category"
                  aria-label="Delete category"
                  onClick={() => {
                    if (window.confirm("Delete the Category?")) {
                      this.deleteCategory(el._id);
                    }
                  }}
                >
                  <FontAwesomeIcon icon={faTrashAlt} style={{ fontSize: "13px" }} />
                </button>
                <button
                  type="button"
                  className="contest-icon-btn"
                  title="Update Category"
                  aria-label="Update category"
                  onClick={() => {
                    this.updateCategory(el._id);
                  }}
                >
                  <FontAwesomeIcon icon={faEdit} style={{ fontSize: "13px" }} />
                </button>
              </div>
            </td>
          </tr>
        );
      });
    }

    let previous = 0;
    let next = 0;
    let customLength = 0;

    if (pageNo !== 0) {
      previous = pageNo - 1;
      next = pageNo + 1;
    }

    if (length !== 0) {
      customLength = length;
    }

    if (length < 2) {
      $(".pagination").hide();
    }

    return (
      <div className="content-page contest-submissions-page contest-management-page category-management-page event-consistent-page">
        <div className="content page-content-spaced">
          <div className="event-management-header">
            <div className="header-content">
              <div className="header-title">
                <h4 className="page-title-heading">Category Management</h4>
                <p className="header-subtitle">
                  Manage multimedia categories, type, and activation status.
                </p>
              </div>
              <div className="header-actions">
                <Link
                  to="/add-category"
                  className="btn btn-primary btn-add-event contest-add-match"
                >
                  + Add New
                </Link>
              </div>
            </div>
          </div>

          <div className="event-management-body">
            <div className="card contest-like-card">
              <div className="card-body">
                <div className="category-management-toolbar">
                  <div className="category-management-filter-group">
                    <select
                      id="selectValue"
                      onChange={() => {
                        this.handleSubmit(this.state.defaultPageNo);
                      }}
                      className="form-control"
                    >
                      <option value="all">Select one</option>
                      <option value="1">Active</option>
                      <option value="0">Inactive</option>
                    </select>
                  </div>
                  <p id="gen-message" className="message-feedback"></p>
                </div>

                <div className="table-wrapper contest-submissions-table-responsive contest-like-table-responsive">
                  <table
                    id="complex-header-datatable"
                    className="table event-table contest-submissions-table contest-like-table category-management-table"
                  >
                    <thead>
                      <tr>
                        <th className="category-sno-col">S.No.</th>
                        <th>Name</th>
                        <th className="category-image-col">Image</th>
                        <th className="category-type-col">Type</th>
                        <th>Created At</th>
                        <th className="category-status-col">Status</th>
                        <th className="actions-col">Action</th>
                      </tr>
                    </thead>
                    <tbody>{bodyData}</tbody>
                  </table>

                  <div className="pagination">
                    {pageNo <= 1 ? (
                      <a>Previous</a>
                    ) : (
                      <a
                        className="paginate-link"
                        onClick={() => this.handleSubmit(previous)}
                      >
                        Previous
                      </a>
                    )}

                    <a>{pageNo}</a>
                    {pageNo >= customLength ? (
                      <a>Next</a>
                    ) : (
                      <a
                        className="paginate-link active"
                        onClick={() => this.handleSubmit(next)}
                      >
                        Next
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default DataManagement;
